// extracted by mini-css-extract-plugin
export default {"welcomeWrapper":"Welcome_welcomeWrapper__NiSbQ","description":"Welcome_description__sgR0h","fadeIn":"Welcome_fadeIn__t3KF5","fadeOut":"Welcome_fadeOut__XgozF"};